import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tomo-i',
  templateUrl: './tomo-i.component.html',
  styleUrls: ['./tomo-i.component.css']
})
export class TomoIComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
